import { Button, UnstyledButton } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import classes from './SchedulingCalendarToolbar.module.css';

export type CalendarNavigationButtonsProps = {
  onNavigate: (action: 'PREV' | 'NEXT' | 'TODAY') => void;
};

export default function CalendarNavigationButtons({ onNavigate }: CalendarNavigationButtonsProps) {
  return (
    <Button.Group>
      <UnstyledButton className={`${classes.actionIconButton}`} onClick={() => onNavigate('PREV')}>
        <IconChevronLeft size={20} />
      </UnstyledButton>
      <UnstyledButton className={`${classes.actionButton} ${classes.actionGroup}`} onClick={() => onNavigate('TODAY')}>
        Today
      </UnstyledButton>
      <UnstyledButton className={`${classes.actionIconButton}`} onClick={() => onNavigate('NEXT')}>
        <IconChevronRight size={20} />
      </UnstyledButton>
    </Button.Group>
  );
}
